import Resource from '@/plugins/sdk/Resource'
import { NUMBER, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Service from '../Carrier/Service'
import ItemsDg from './ItemsDg'
// import Account from '@/plugins/sdk/resources/Account'
// import CarrierService from '@/plugins/sdk/resources/Account/CarrierSetting'

export default class extends Resource {
  static name = 'account_item'

  static get fields () {
    return {
      'id': new UUID(),
      'name': new STRING(),
      'code': new STRING(),
      'default_qty': new NUMBER(),
      'weight': new NUMBER(),
      'length': new NUMBER(),
      'width': new NUMBER(),
      'height': new NUMBER(),
      'service': new ITEM(Service),
      'dg': new ITEM(ItemsDg)
    }
  }

  static get sortables () {
    return [
      { field: 'name', label: 'Name' },
      { field: 'code', label: 'Code' },
      { field: 'default_qty', label: 'Default Quantity' },
      { field: 'weight', label: 'Weight' },
      { field: 'length', label: 'Length' },
      { field: 'width', label: 'Width' },
      { field: 'height', label: 'Height' },
      { field: 'service.name', label: 'Service Name' }
    ]
  }
}
